module.exports = __webpack_public_path__ + "img/ball_1.e071075b.png";